import { useMediaQuery } from "react-responsive";

import { breakpoints } from "@/config/breakpoints";

export const useDeviceType = () => {
  const isMobile = useMediaQuery({
    maxWidth: breakpoints.mobileMax,
  });

  const isTablet = useMediaQuery({
    minWidth: breakpoints.tabletMin,
    maxWidth: breakpoints.tabletMax,
  });

  const isDesktop = useMediaQuery({
    minWidth: breakpoints.desktopMin,
  });

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
